module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"fp-text-1":"Tervetuloa Oma B2 Impact -palveluun"},"se":{"fp-text-1":"Välkommen till Min B2 Impact -webbtjänsten!"},"en":{"fp-text-1":"Welcome to My B2 Impact service"}}')
  delete Component.options._Ctor
}
